const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Whether the chart may animate: not with `prefers-reduced-motion: reduce`
 * and not in a background tab. `onChange` is called when either changes.
 *
 * @param {() => void} onChange
 * @returns {{ isEnabled: boolean, stop: () => void }}
 */
export const watchMotionPreference = (onChange) => {
  const reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY);

  reducedMotion.addEventListener("change", onChange);
  document.addEventListener("visibilitychange", onChange);

  return {
    get isEnabled() {
      return !reducedMotion.matches && !document.hidden;
    },

    stop: () => {
      reducedMotion.removeEventListener("change", onChange);
      document.removeEventListener("visibilitychange", onChange);
    },
  };
};
